module.exports = __webpack_public_path__ + "media/open.32abacee.mp3";